module.exports = __webpack_public_path__ + "img/login_bg_left.bdba43bb.png";